import { Box, Link } from '@firsttable/web-components/atoms';
import BodyTitle from '@firsttable/web-components/atoms/BodyTitle';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { scrollTo } from '@firsttable/functions';
import { TrackProvider } from '@/components/analytics/context/AnalyticsContext';

const OpenHours = styled(Box)`
  white-space: pre-wrap;
`;

const Contacts = ({ restaurant, toggleContactsState }) => {
  const anchor = 'Contacts';

  useEffect(() => {
    if (toggleContactsState) {
      scrollTo(anchor);
    }
  }, [toggleContactsState]);

  return (
    <Box
      display={toggleContactsState ? 'flex' : 'none'}
      mb={20}
      pb={20}
      flexWrap="wrap"
      borderBottom="1px solid"
      borderColor="grayscale.300"
      id={anchor}>
      <Box width={['100%', 1 / 3.33]} mr="5%" pb={[10, 0]}>
        <BodyTitle size="xs" mb="xs">
          Address:
        </BodyTitle>
        {restaurant.street}
        <br />
        {restaurant.city} {restaurant.zip}
      </Box>
      <Box width={['100%', 1 / 3.33]} pb={[10, 0]}>
        <BodyTitle size="xs" mb="xs">
          Phone:
        </BodyTitle>
        {restaurant.phone}
      </Box>
      {restaurant.website && (
        <Box width={['100%', 1 / 3.33]} pb={[10, 0]}>
          <BodyTitle size="xs" mb="xs">
            Website:
          </BodyTitle>
          <TrackProvider link_name="restaurant website">
            <Link href={restaurant.website} underline>
              Click here to view
            </Link>
          </TrackProvider>
        </Box>
      )}
      {restaurant.openHours && (
        <Box width="100%" mt={[0, 10]}>
          <BodyTitle size="xs" mb="xs">
            Open hours:
          </BodyTitle>
          <OpenHours>{restaurant.openHours}</OpenHours>
        </Box>
      )}
    </Box>
  );
};

Contacts.propTypes = {
  restaurant: PropTypes.object.isRequired,
  toggleContactsState: PropTypes.bool.isRequired,
};
export default Contacts;
